import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  persistReducer,
} from "redux-persist";
import Constants from "expo-constants";

import authReducer from "./features/auth";
import registerReducer from "./features/register";
import loaderReducer from "./features/loader";
import itemReducer from "./features/items";
import orderReducer from "./features/orders";
import toastReducer from "./features/toast";
import storeReducer from "./features/stores";
import storeDetailReducer from "./features/store";
import storeItemSliceReducer from "./features/storeItems";
import cartReducer from "./features/cart";
import masterReducer from "./features/master";
import userReducer from "./features/user";
import languageReducer from "./features/language";
import selectedAddressReducer from "./features/selectedAddress";
import mapboxReducer from "./features/mapbox";
import deviceReducer from "./features/device";
import storeOrderReducer from "./features/storeOrders";
import merchantStoreItemsReducer from "./features/merchantStoreItems";
import merchantReducer from "./features/merchant";
import paymentReducer from "./features/payment";
import orderNotificationsReducer from "./features/orderNotifications";
import categoriesReducer from "./features/categories";
import recentSearchReducer from "./features/recentSearch";

import storage from "@react-native-async-storage/async-storage";
// TODO
// import createSecureStorage from "./secureStorage";

// const storage = createSecureStorage();

const rootReducer = combineReducers({
  auth: authReducer,
  register: registerReducer,
  loader: loaderReducer,
  items: itemReducer,
  orders: orderReducer,
  toast: toastReducer,
  store: storeReducer,
  storeDetail: storeDetailReducer,
  storeItems: storeItemSliceReducer,
  cart: cartReducer,
  master: masterReducer,
  user: userReducer,
  language: languageReducer,
  selectedAddress: selectedAddressReducer,
  mapbox: mapboxReducer,
  device: deviceReducer,
  storeOrder: storeOrderReducer,
  merchantStoreItems: merchantStoreItemsReducer,
  merchant: merchantReducer,
  payment: paymentReducer,
  orderNotifications: orderNotificationsReducer,
  categories: categoriesReducer,
  recentSearch: recentSearchReducer,
});

const extras = Constants.expoConfig?.extra;
const client = process.env.CLIENT || extras?.client;

const persistConfig = {
  key: client,
  version: 1,
  storage,
  whitelist: [
    "auth",
    "cart",
    "language",
    "selectedAddress",
    "merchant",
    "recentSearch",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export { store };
